import { render, staticRenderFns } from "./ButtonEdit.vue?vue&type=template&id=1096af0a&scoped=true&"
import script from "./ButtonEdit.vue?vue&type=script&lang=js&"
export * from "./ButtonEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1096af0a",
  null
  
)

export default component.exports